import { ColorSwatchCategory, hexColorSwatches } from "@nova/constants"
import { encodeColorToNumber } from "@nova/serializer/src/client/util"
import { UsageModel } from "@nova/db-table-usage"

export const cachedUsageByEntityId: Record<string, { usage: UsageModel; fileCount: number }> = {}

export const scanAreaFillColorSwatches = hexColorSwatches[ColorSwatchCategory.ScanAreaFill].map(
    (hex) => encodeColorToNumber(hex)
)
export const scanAreaOutlineColorSwatches = hexColorSwatches[
    ColorSwatchCategory.ScanAreaOutline
].map((hex) => encodeColorToNumber(hex))
